import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { modalDidMount, modalWillUnmount } from './ModalFixMixin';

import AutoUserInput from './AutoUserInput';
import ColorPicker from './ColorPicker';

require.ensure([], () => {
    require('./NewTaskWidget.less');
});

class NewProjectWidget extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            color: "",
            manager: null,
            name: "",
            pmName: "",
            sponsor: null,
            sponsorName: ""
        };
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        modalDidMount();
        ReactDOM.findDOMNode(this.refs.nameInput).focus();
        this.refs.colorPicker.selectDefault();
    }

    componentWillUnmount = () => { modalWillUnmount(); }

    // EVENT HANDLERS

    handleClose = () => { this.props.handleClose(); }

    handleColorChange = (color) => { this.setState({ color: color }); }

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter") {
            this.handleSave();
        }
        keyEvent.stopPropagation();
    }

    handleKeyUp = (keyEvent) => {
        if (keyEvent.key === "Escape") {
            this.handleClose();
        }
        keyEvent.stopPropagation();
    }

    handleNameChange = (event) => {
        let name = event.target.value.trim();

        this.setState({
            name: event.target.value,
            nameError: name === '' || this._projectExists(name) !== -1 ? true : false
        });
    }

    handlePmClick = (user) => { this.setState({ manager: user }); }

    handleSponsorClick = (user) => { this.setState({ sponsor: user }); }

    handleSponsorTextChange = (text) => {
      if(text !== undefined) {
        text.trim() === '' ?  this.setState({sponsor: null})  : this.setState({sponsor: text});
      }
    }

    handleRefocus = () => {
        ReactDOM.findDOMNode(this.refs.nameInput).focus();
    }

    handleSave = () => {
        let project = {
            billable: !(this.state.name.substring(0, 4).toUpperCase() == "CROZ"),
            defaultColor: this.state.color,
            manager: this.state.manager,
            name: this.state.name,
            productive: true,
            sponsor: this.state.sponsor,
            startDate: moment().format("YYYY-MM-DD")
        };

        this.validate();

        if (!this.state.nameError && !this.state.managerError && !this.state.sponsorError) {
            this.props.handleSave(project);
            this.handleClose();
        }
    }

    // OTHER METHODS

    _projectExists = (name) => {
        let searchElement = name.toLowerCase();

        let minIndex = 0;
        let maxIndex = this.props.projectNames.length - 1;
        let currentIndex;
        let currentElement;

        while (minIndex <= maxIndex) {
            currentIndex = (minIndex + maxIndex) / 2 | 0;
            currentElement = this.props.projectNames[currentIndex];

            if (currentElement < searchElement) {
                minIndex = currentIndex + 1;
            } else if (currentElement > searchElement) {
                maxIndex = currentIndex -1;
            } else {
                return currentElement;
            }
        }

        return -1;
    }

    validate = () => {
        this.state.nameError = this.state.name.trim() === '' || this._projectExists(this.state.name) !== -1 ? true : false;

        //sometimes there is no manager, sometimes a manager is an empty object - we need to check for both
        this.state.managerError = this.state.manager === null ? true : false;
        if (this.state.manager) {
            this.state.managerError = this.state.manager.id ? false : true;
        }

        this.state.sponsorError = this.state.sponsor === null ? true : false;
        if (this.state.sponsor) {
          this.state.sponsorError = this.state.sponsor.id ? false : true;
        }
        
        this.forceUpdate();
    }

    // RENDER METHOD

    render = () => {
        return (
            <Modal show={true} onKeyUp={this.handleKeyUp} onKeyPress={this.handleKeyPress} className="modal fade" id="myModal3" tabIndex="-1" role="dialog" aria-labelledby="myModal3Label" aria-hidden="true">
                <div className="modal-dialog new-log-entry" >
                    <div className="modal-content">
                        <form>
                            <div className="modal-header">
                                <button style={{marginTop : "-20px", marginRight : "-5px"}} onClick={this.handleClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                                <h4 className="modal-title" id="myModalLabel">New Project</h4>
                            </div>
                            <div className="modal-body">
                                <span className={this.state.nameError ? "has-error" : null}>
                                    <input ref="nameInput" value={this.state.name} onChange={this.handleNameChange} type="text" className="form-control" placeholder="Project Name"/>
                                </span>
                                <span className={this.state.managerError ? "has-error" : null}>
                                    <AutoUserInput
                                        bannedUser={null}
                                        enableClear
                                        forceInitialPopup={false}
                                        handleFunction={this.handlePmClick}
                                        keepAfterClick={true}
                                        placeholder="Project Manager"
                                        text={this.state.pmName}
                                        users={this.props.pmUsers}
                                        />
                                </span>
                                <span className={this.state.sponsorError ? "has-error" : null}>
                                    <AutoUserInput
                                        bannedUser={null}
                                        enableClear
                                        forceInitialPopup={false}
                                        handleFunction={this.handleSponsorClick}
                                        handleTextChange={this.handleSponsorTextChange}
                                        keepAfterClick={true}
                                        placeholder="Project Sponsor"
                                        text={this.state.sponsorName}
                                        users={this.props.sponsorUsers}
                                        />
                                </span>
                                <ColorPicker
                                    ref="colorPicker"
                                    title="Project color"
                                    handleColorChange={this.handleColorChange}
                                    />
                            </div>
                            <div className="modal-footer">
                                <button title="Create project" type="button" className="btn btn-default btn-large" onClick={this.handleSave}>Create</button>
                                <button title="Cancel and close dialog" onBlur={this.handleRefocus} type="button" className="btn btn-default btn-discrete" data-dismiss="modal" onClick={this.handleClose}>Close</button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        );
    }
}

NewProjectWidget.propTypes = {
    handleClose: PropTypes.func,
    handleSave: PropTypes.func,
    pmUsers: PropTypes.array,
    projectNames: PropTypes.array,
    sponsorUsers: PropTypes.array
};

const mapStateToProps = (state) => {
    return {
        pmUsers: state.users.pms.users,
        sponsorUsers: state.users.sponsorUsers,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewProjectWidget);



/** WEBPACK FOOTER **
 ** ./src/app/components/NewProjectWidget.js
 **/